import {Environment} from "./ienvironment";

export const environment: Environment = {
  production: false,
  name: 'dev',
  pocketbaseUrl: 'https://pocketbase-dev.bogner.systems'
}
